import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: "62f89fcdd3f0aa3df7ca94e1",
    id: 1,
    title: "Harry Potter Complete Set",
    author: "J.K. Rowling",
    description:
      "Over 4000 pages of Harry Potter and his world, including all 7 books.\nAll seven eBooks in the multi-award winning, internationally bestselling Harry Potter series, available as one download with stunning cover art by Olly Moss. Enjoy the stories that have captured the imagination of millions worldwide.",
    bookType: "Hardcover",
    inStock: true,
    genres: ["Fiction", "Fantasy", "Young Adult", "Adventure", "Childrens"],
    coverImg:
      "https://prodimage.images-bn.com/lf?set=key%5Bresolve.pixelRatio%5D,value%5B1%5D&set=key%5Bresolve.width%5D,value%5B550%5D&set=key%5Bresolve.height%5D,value%5B10000%5D&set=key%5Bresolve.imageFit%5D,value%5Bcontainerwidth%5D&set=key%5Bresolve.allowImageUpscaling%5D,value%5B0%5D&product=path%5B/pimages/9780545162074_p3_v1%5D&call=url%5Bfile:common/decodeProduct.chain%5D",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94e2",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94e3",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94e4",
      },
    ],
    originalPrice: 1450,
    discountPercent: 45,
    discountPrice: 451,
    totalRatings: 82150,
    totalStars: 4.8,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.703Z",
    updatedAt: "2022-08-14T07:10:05.703Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94e5",
    id: 2,
    title: "7 Mindsets for Success, Happiness and Fulfilment",
    author: "Swami Mukundananda",
    description:
      "Thoughts and feelings that persist over time harden into an attitude. If you live with an attitude long enough, it becomes second nature—a mindset. The wrong mindset could lead you off the path of contentment, joy, enlightenment. The right one will point you to the road to success, to fulfilment and towards an extraordinary life.\n\nBlending science with Vedic scriptures, and logic with spiritual insight, Swami Mukundananda unravels the secrets of the 7 mindsets—seven techniques of training the mind and intellect and unlocking the immense potential within.",
    bookType: "Paperback",
    inStock: true,
    genres: [
      "Non-Fiction",
      "Spirituality",
      "Self Help",
      "Philosophy",
      "Psychology",
    ],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1569209892l/51987423._SX318_SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94e6",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94e7",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94e8",
      },
    ],
    originalPrice: 295,
    discountPercent: 23,
    discountPrice: 67,
    totalRatings: 372,
    totalStars: 4.5,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.709Z",
    updatedAt: "2022-08-14T07:10:05.709Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94e9",
    id: 3,
    title: "Love on the Brain",
    author: "Ali Hazelwood",
    description:
      "From the New York Times bestselling 'author' of The Love Hypothesis comes a new STEMinist rom-com in which a scientist, Bee Königswasser, is forced to work on a project with her nemesis, Levi Ward—with explosive results.",
    bookType: "Paperback",
    inStock: false,
    genres: ["Romance", "Contemporary Romance", "Adult", "Fiction", "Academic"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1642069168l/59571699._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94ea",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94eb",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94ec",
      },
    ],
    originalPrice: 472,
    discountPercent: 44,
    discountPrice: 207,
    totalRatings: 879,
    totalStars: 4.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.711Z",
    updatedAt: "2022-08-14T07:10:05.711Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94ed",
    id: 4,
    title: "Why We Sleep: Unlocking the Power of Sleep and Dreams",
    author: "Matthew Walker",
    description:
      "Neuroscientist and sleep expert Matthew Walker provides a revolutionary exploration of sleep, examining how it affects every aspect of our physical and mental well-being. Charting the most cutting-edge scientific breakthroughs, and marshalling his decades of research and clinical practice, Walker explains how we can harness sleep to improve learning, mood and energy levels, regulate hormones, prevent cancer, Alzheimer's and diabetes, slow the effects of aging, and increase longevity. He also provides actionable steps towards getting a better night's sleep every night.",
    bookType: "Paperback",
    inStock: true,
    genres: [
      "Non-Fiction",
      "Neuroscience",
      "Health",
      "Psychology",
      "Self Help",
    ],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1556604137l/34466963._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94ee",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94ef",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94f0",
      },
    ],
    originalPrice: 799,
    discountPercent: 15,
    discountPrice: 200,
    totalRatings: 129469,
    totalStars: 4.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.712Z",
    updatedAt: "2022-08-14T07:10:05.712Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94f1",
    id: 5,
    title: "The Krishna Key",
    author: "Ashwin Sanghi",
    description:
      "Ashwin Sanghi brings you yet another exhaustively researched whopper of a plot, while providing an incredible alternative interpretation of the Vedic Age that will be relished by conspiracy buffs and thriller-addicts alike.\n\nHistorian Ravi Mohan Saini must breathlessly dash from the submerged remains of Dwarka and the mysterious lingam of Somnath to the icy heights of Mount Kailash, in a quest to discover the cryptic location of Krishna's most prized possession. From the sand-washed ruins of Kalibangan to a Vrindavan temple destroyed by Aurangzeb, Saini must also delve into antiquity to prevent a gross miscarriage of justice.",
    bookType: "Paperback",
    inStock: false,
    genres: ["Fiction", "Thriller", "Mythology", "History", "Mystery"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1341289060l/15733523.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94f2",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94f3",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94f4",
      },
    ],
    originalPrice: 450,
    discountPercent: 2,
    discountPrice: 10,
    totalRatings: 19017,
    totalStars: 3.6,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.716Z",
    updatedAt: "2022-08-14T07:10:05.716Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94f5",
    id: 6,
    title: "Atomic Habits",
    author: "James Clear",
    description:
      "No matter your goals, Atomic Habits 'offers' a proven framework for improving--every day. James Clear, one of the world's leading experts on habit formation, reveals practical strategies that will teach you exactly how to form good habits, break bad ones, and master the tiny behaviors that lead to remarkable results.",
    bookType: "Hardcover",
    inStock: true,
    genres: ["Non-Fiction", "Health", "Self Help", "Philosophy", "Science"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1535115320l/40121378._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94f6",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94f7",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94f8",
      },
    ],
    originalPrice: 999,
    discountPercent: 27,
    discountPrice: 300,
    totalRatings: 347170,
    totalStars: 4.6,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.718Z",
    updatedAt: "2022-08-14T07:10:05.718Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94f9",
    id: 7,
    title: "Attitude Is Everything",
    author: "Jeff Keller",
    description:
      "This is a 'success manual' that gives readers a step by step plan for taking control of their lives and unleashing their incredible potential. The book consists of 12 Lessons that was used by 'author' Jeff Keller to make a career transition from lawyer to motivational speaker. The book shows readers how they, too, can make positive changes in every area of their lives.",
    bookType: "Paperback",
    inStock: true,
    genres: [
      "Non-Fiction",
      "Self Help",
      "Personal Development",
      "Leadership",
      "Motivational",
    ],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1482649723l/33561786._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94fa",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94fb",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94fc",
      },
    ],
    originalPrice: 699,
    discountPercent: 14,
    discountPrice: 170,
    totalRatings: 2886,
    totalStars: 4.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.720Z",
    updatedAt: "2022-08-14T07:10:05.720Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca94fd",
    id: 8,
    title: "The Book Theif",
    author: "Markus Zusak",
    description:
      "It is 1939. Nazi Germany. The country is holding its breath. Death has never been busier, and will be busier still.\n\nBy her brother's graveside, Liesel's life is changed when she picks up a single object, partially hidden in the snow. It is The Gravedigger's Handbook, left behind there by accident, and it is her first act of book thievery. So begins a love affair with books and words, as Liesel, with the help of her accordian-playing foster father, learns to read. Soon she is stealing books from Nazi book-burnings, the mayor's wife's library, wherever there are books to be found.\n\nBut these are dangerous times. When Liesel's foster family hides a Jew in their basement, Liesel's world is both opened up, and closed down.",
    bookType: "Paperback",
    inStock: true,
    genres: ["History", "Fiction", "Young Adult", "Classics", "War"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1522157426l/19063._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca94fe",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca94ff",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9500",
      },
    ],
    originalPrice: 799,
    discountPercent: 29,
    discountPrice: 230,
    totalRatings: 2143296,
    totalStars: 4.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.722Z",
    updatedAt: "2022-08-14T07:10:05.722Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9501",
    id: 9,
    title: "The Da Vinci Code",
    author: "Dan Brown",
    description:
      "While in Paris, Harvard symbologist Robert Langdon is awakened by a phone call in the dead of the night. The elderly curator of the Louvre has been murdered inside the museum, his body covered in baffling symbols. As Langdon and gifted French cryptologist Sophie Neveu sort through the bizarre riddles, they are stunned to discover a trail of clues hidden in the works of Leonardo da Vinci—clues visible for all to see and yet ingeniously disguised by the painter.\n\nEven more startling, the late curator was involved in the Priory of Sion—a secret society whose members included Sir Isaac Newton, Victor Hugo, and Da Vinci—and he guarded a breathtaking History secret. Unless Langdon and Neveu can decipher the labyrinthine puzzle—while avoiding the faceless adversary who shadows their every move—the explosive, ancient truth will be lost forever",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fiction", "Mystery", "Thriller", "Suspense", "Adventure"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1579621267l/968.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9502",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9503",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9504",
      },
    ],
    originalPrice: 499,
    discountPercent: 34,
    discountPrice: 169,
    totalRatings: 7686,
    totalStars: 4.6,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.724Z",
    updatedAt: "2022-08-14T07:10:05.724Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9505",
    id: 10,
    title: "Lean In: Women, Work, and the Will to Lead",
    author: "Sheryl Sandberg",
    description:
      "In Lean In, Sheryl Sandberg- Facebook COO and one of Fortune magazine's Most Powerful Women in Business- draws on her own experience of working in some of the world's most successful businesses and looks at what women can do to help themselves, and make the small changes in their life that can effect change on a more universal scale.",
    bookType: "Hardcover",
    inStock: true,
    genres: [
      "Non-Fiction",
      "Feminism",
      "Leadership",
      "Business",
      "Autobiography",
    ],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1630483761l/16071764._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9506",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9507",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9508",
      },
    ],
    originalPrice: 999,
    discountPercent: 15,
    discountPrice: 231,
    totalRatings: 243804,
    totalStars: 3.9,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.726Z",
    updatedAt: "2022-08-14T07:10:05.726Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9509",
    id: 11,
    title: "Divergent Series Complete Set",
    author: "Veronica Roth",
    description:
      "All three books in the #1 New York Times bestselling Divergent trilogy are available together for the first time! The collection includes Divergent, Insurgent, and Allegiant, as well as bonus content: a 48-page guide to the series, including Faction Manifestos, a Faction Quiz and Results, a Q&A with Veronica Roth, playlists, discussion questions, series inspirations, and much more!",
    bookType: "Paperback",
    inStock: true,
    genres: ["Dystopian", "Fiction", "Fantasy", "Romance", "Young Adult"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1372682053l/17383994.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca950a",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca950b",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca950c",
      },
    ],
    originalPrice: 1599,
    discountPercent: 40,
    discountPrice: 637,
    totalRatings: 43526,
    totalStars: 3.2,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.727Z",
    updatedAt: "2022-08-14T07:10:05.727Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca950d",
    id: 12,
    title: "A Man Called Ove",
    author: "Fredrik Backman",
    description:
      "First, there were ten—a curious assortment of strangers summoned as weekend guests to a little private island off the coast of Devon. Their host, an eccentric millionaire unknown to all of them, is nowhere to be found. All that the guests have in common is a wicked past they're unwilling to reveal—and a secret that will seal their fate. For each has been marked for murder.\nWhen they realize that murders are occurring as described in the rhyme, terror mounts. One by one they fall prey. Before the weekend is out, there will be none. Who has choreographed this dastardly scheme? And who will be left to tell the tale? Only the dead are above suspicion.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fiction", "Contemporary", "Humor", "Adult", "Novel"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1405259930l/18774964.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca950e",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca950f",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9510",
      },
    ],
    originalPrice: 599,
    discountPercent: 26,
    discountPrice: 129,
    totalRatings: 32852,
    totalStars: 4.5,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.729Z",
    updatedAt: "2022-08-14T07:10:05.729Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9511",
    id: 13,
    title: "And Then There Were None",
    author: "Agatha Christie",
    description:
      "First, there were ten—a curious assortment of strangers summoned as weekend guests to a little private island off the coast of Devon. Their host, an eccentric millionaire unknown to all of them, is nowhere to be found. All that the guests have in common is a wicked past they're unwilling to reveal—and a secret that will seal their fate. For each has been marked for murder. A famous nursery rhyme is framed and hung in every room of the mansion.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Mystery", "Classics", "Fiction", "Thriller", "Crime"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1638425885l/16299._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9512",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9513",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9514",
      },
    ],
    originalPrice: 199,
    discountPercent: 40,
    discountPrice: 79,
    totalRatings: 16870,
    totalStars: 4.2,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.731Z",
    updatedAt: "2022-08-14T07:10:05.731Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9515",
    id: 14,
    title: "Palace of Illusions",
    author: "Chitra Banerjee Divakaruni",
    description:
      "A reimagining of the world-famous Indian epic, the Mahabharat—told from the point of view of an amazing woman.\n\nRelevant to today's war-torn world, The Palace of Illusions takes us back to a time that is half history, half myth, and wholly magical. Narrated by Panchaali, the wife of the legendary Pandavas brothers in the Mahabharat, the novel gives us a new interpretation of this ancient tale.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fiction", "Mythology", "History", "Retellins", "Cultural"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1396229073l/1774836.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9516",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9517",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9518",
      },
    ],
    originalPrice: 450,
    discountPercent: 42,
    discountPrice: 187,
    totalRatings: 42043,
    totalStars: 4.2,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.732Z",
    updatedAt: "2022-08-14T07:10:05.732Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9519",
    id: 15,
    title: "Twilight",
    author: "Stephenie Meyer",
    description:
      "A reimagining of the world-famous Indian epic, the Mahabharat—told from the point of view of an amazing woman.\n\nRelevant to today's war-torn world, The Palace of Illusions takes us back to a time that is half history, half myth, and wholly magical. Narrated by Panchaali, the wife of the legendary Pandavas brothers in the Mahabharat, the novel gives us a new interpretation of this ancient tale.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fantasy", "Young Adult", "Romance", "Fiction", "Paranomal"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1361039443l/41865.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca951a",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca951b",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca951c",
      },
    ],
    originalPrice: 499,
    discountPercent: 20,
    discountPrice: 100,
    totalRatings: 5671177,
    totalStars: 2.7,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.733Z",
    updatedAt: "2022-08-14T07:10:05.733Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca951d",
    id: 16,
    title: "Pride and Prejudice",
    author: "Jane Austen",
    description:
      "When Elizabeth Bennet meets Fitzwilliam Darcy for the first time at a ball, she writes him off as an arrogant and obnoxious man. He not only acts like an insufferable snob, but she also overhears him rejecting the very idea of asking her for a dance! As life pits them against each other again and again, Darcy begins to fall for Elizabeth's wit and intelligence and Elizabeth begins to question her feelings about Darcy. When Darcy saves her youngest sister, Lydia, from a scandal, Elizabeth starts to wonder if her pride has prejudiced her opinion of Darcy.",
    bookType: "Hardcover",
    inStock: false,
    genres: ["Classics", "Fiction", "Romance", "History", "Novel"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1320399351l/1885.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca951e",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca951f",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9520",
      },
    ],
    originalPrice: 1299,
    discountPercent: 26,
    discountPrice: 334,
    totalRatings: 25340,
    totalStars: 4.6,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.734Z",
    updatedAt: "2022-08-14T07:10:05.734Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9521",
    id: 17,
    title: "Wings of Fire",
    author: "Dr. A.P.J. Abdul Kalam and Arun Tiwari",
    description:
      "This is the story of Kalam's rise from obscurity and his personal and professional struggles, as well as the story of Agni, Prithvi, Akash, Trishul and Nag-missiles that have become household names in India and that have raised the nation to the level of a missile power of international reckoning. This is also the saga of independent India's struggle for technological self-sufficiency and defensive autonomy-a story as much about politics, domestic and international, as it is about science",
    bookType: "Paperback",
    inStock: true,
    genres: ["Biography", "Non-Fiction", "Inspirational", "Science", "History"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1588286863l/634583._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9522",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9523",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9524",
      },
    ],
    originalPrice: 299,
    discountPercent: 36,
    discountPrice: 109,
    totalRatings: 46630,
    totalStars: 4.3,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.738Z",
    updatedAt: "2022-08-14T07:10:05.738Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9525",
    id: 18,
    title: "Love Hypothesis",
    author: "Ali Hazelwood",
    description:
      "As a third-year Ph.D. candidate, Olive Smith doesn't believe in lasting romantic relationships--but her best friend does, and that's what got her into this situation. Convincing Anh that Olive is dating and well on her way to a happily ever after was always going to take more than hand-wavy Jedi mind tricks: Scientists require proof. So, like any self-respecting biologist, Olive panics and kisses the first man she sees.\n\nThat man is none other than Adam Carlsen, a young hotshot professor who agrees to keep her charade a secret and be her fake boyfriend. Suddenly their little experiment feels dangerously close to combustion. And Olive discovers that the only thing more complicated than a hypothesis on love is putting her own heart under the microscope.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Romance", "Contemporary Romance", "Adult", "Fiction", "Academic"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1611937942l/56732449.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9526",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9527",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9528",
      },
    ],
    originalPrice: 493,
    discountPercent: 44,
    discountPrice: 216,
    totalRatings: 10256,
    totalStars: 4.7,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.739Z",
    updatedAt: "2022-08-14T07:10:05.739Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9529",
    id: 19,
    title: "The Psychology of Money",
    author: "Morgan Housel",
    description:
      "Money—investing, personal finance, and business decisions—is typically taught as a math-based field, where data and formulas tell us exactly what to do. But in the real world people don't make financial decisions on a spreadsheet. They make them at the dinner table, or in a meeting room, where personal history, your own unique view of the world, ego, pride, marketing, and odd incentives are scrambled together.\n\nIn The Psychology of Money, award-winning 'author' Morgan Housel shares 19 short stories exploring the strange ways people think about money and teaches you how to make better sense of one of life's most important topics",
    bookType: "Paperback",
    inStock: true,
    genres: ["Economics", "Finance", "Psychology", "Business", "Self Help"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1581527774l/41881472._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca952a",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca952b",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca952c",
      },
    ],
    originalPrice: 399,
    discountPercent: 27,
    discountPrice: 109,
    totalRatings: 51051,
    totalStars: 4.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.741Z",
    updatedAt: "2022-08-14T07:10:05.741Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca952d",
    id: 20,
    title: "Harry Potter and the Cursed Child: Parts One and Two",
    author: "John Tiffany (Adaptation), Jack Thorne, J.K. Rowling",
    description:
      "It was always difficult being Harry Potter and it isn't much easier now that he is an overworked employee of the Ministry of Magic, a husband and father of three school-age children.\n\nWhile Harry grapples with a past that refuses to stay where it belongs, his youngest son Albus must struggle with the weight of a family legacy he never wanted. As past and present fuse ominously, both father and son learn the uncomfortable truth: sometimes, darkness comes from unexpected places.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fiction", "Fantasy", "Young Adult", "Adventure", "Childrens"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1470082995l/29056083._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca952e",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca952f",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9530",
      },
    ],
    originalPrice: 399,
    discountPercent: 40,
    discountPrice: 159,
    totalRatings: 848359,
    totalStars: 1.9,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.742Z",
    updatedAt: "2022-08-14T07:10:05.742Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9531",
    id: 21,
    title: "The Courage to Be Disliked",
    author: "Ichiro Kishimi and Fumitake Koga",
    description:
      "The Courage to be Disliked shows you how to unlock the power within yourself to become your best and truest self, change your future and find lasting happiness. Using the theories of Alfred Adler, one of the three giants of 19th century psychology alongside Freud and Jung, the authors explain how we are all free to determine our own future free of the shackles of past experiences, doubts and the expectations of others. It’s a philosophy that’s profoundly liberating, allowing us to develop the courage to change, and to ignore the limitations that we and those around us can place on ourselves.",
    bookType: "Hardcover",
    inStock: true,
    genres: [
      "Non-Fiction",
      "Self Help",
      "Philosophy",
      "Psychology",
      "Mental Health",
    ],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1545421684l/43306206._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9532",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9533",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9534",
      },
    ],
    originalPrice: 499,
    discountPercent: 32,
    discountPrice: 160,
    totalRatings: 36382,
    totalStars: 4.1,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.744Z",
    updatedAt: "2022-08-14T07:10:05.744Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9535",
    id: 22,
    title: "City of Bones",
    author: "Cassandra Clare",
    description:
      "When fifteen-year-old Clary Fray heads out to the Pandemonium Club in New York City, she hardly expects to witness a murder― much less a murder committed by three teenagers covered with strange tattoos and brandishing bizarre weapons. Then the body disappears into thin air. It's hard to call the police when the murderers are invisible to everyone else and when there is nothing―not even a smear of blood―to show that a boy has died. Or was he a boy?",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fantasy", "Young Adult", "Romance", "Paranomal", "Fiction"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1432730315l/256683._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9536",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9537",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9538",
      },
    ],
    originalPrice: 450,
    discountPercent: 25,
    discountPrice: 124,
    totalRatings: 22751,
    totalStars: 2.4,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.745Z",
    updatedAt: "2022-08-14T07:10:05.745Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9539",
    id: 23,
    title: "To Kill a Mockingbird",
    author: "Harper Lee",
    description:
      "Compassionate, dramatic, and deeply moving, 'To Kill A Mockingbird' takes readers to the roots of human behavior - to innocence and experience, kindness and cruelty, love and hatred, humor and pathos. Now with over 18 million copies in print and translated into forty languages, this regional story by a young Alabama woman claims universal appeal. Harper Lee always considered her book to be a simple love story. Today it is regarded as a masterpiece of American literature.",
    bookType: "Paperback",
    inStock: false,
    genres: ["Fiction", "Classics", "History", "Academic", "Young Adult"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1553383690l/2657.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca953a",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca953b",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca953c",
      },
    ],
    originalPrice: 559,
    discountPercent: 39,
    discountPrice: 232,
    totalRatings: 5202423,
    totalStars: 3.7,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.747Z",
    updatedAt: "2022-08-14T07:10:05.747Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca953d",
    id: 24,
    title: "The Great Railway Bazaar",
    author: "Paul Theroux",
    description:
      "First published in 1975, Paul Theroux's strange, unique, and hugely entertaining railway odyssey has become a modern classic of travel literature. Here Theroux recounts his early adventures on an unusual grand continental tour. Brimming with Theroux's signature humor and wry keen observations, this engrossing chronicle is essential reading for both the ardent adventurer and the armchair traveler.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Travel", "Non-Fiction", "Cultural", "Autobiography", "Classics"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1440437557l/63689._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca953e",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca953f",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9540",
      },
    ],
    originalPrice: 399,
    discountPercent: 37,
    discountPrice: 140,
    totalRatings: 18293,
    totalStars: 3.5,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.748Z",
    updatedAt: "2022-08-14T07:10:05.748Z",
  },
  {
    _id: "62f89fcdd3f0aa3df7ca9541",
    id: 25,
    title: "House of Sky and Breath",
    author: "Sarah J. Maas",
    description:
      "Bryce Quinlan and Hunt Athalar are trying to get back to normal―they may have saved Crescent City, but with so much upheaval in their lives lately, they mostly want a chance to relax. Slow down. Figure out what the future holds.\nIn this action-packed sequel to the #1 bestseller House of Earth and Blood, Sarah J. Maas weaves a captivating story of a world about to explode―and the people who will do anything to save it.",
    bookType: "Paperback",
    inStock: true,
    genres: ["Fantasy", "Romance", "Adult", "Fairies", "Fiction"],
    coverImg:
      "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1633097753l/40132775._SY475_.jpg",
    offers: [
      {
        id: 1,
        offer: "fastDelivery",
        offerText: "Fast Delivery",
        isOffer: true,
        _id: "62f89fcdd3f0aa3df7ca9542",
      },
      {
        id: 2,
        offer: "newArrival",
        offerText: "New Arrival",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9543",
      },
      {
        id: 3,
        offer: "bestSeller",
        offerText: "Best Seller",
        isOffer: false,
        _id: "62f89fcdd3f0aa3df7ca9544",
      },
    ],
    originalPrice: 799,
    discountPercent: 34,
    discountPrice: 270,
    totalRatings: 59559,
    totalStars: 4.6,
    __v: 0,
    createdAt: "2022-08-14T07:10:05.749Z",
    updatedAt: "2022-08-14T07:10:05.749Z",
  },
];